import client from './client';

export const notificationsApi = {
  async getNotifications() {
    const { data } = await client.get('/api/notifications');
    return data;
  },

  async markAsRead(id) {
    const { data } = await client.post(`/api/notifications/${id}/read`);
    return data;
  },

  async markAllAsRead() {
    const { data } = await client.post('/api/notifications/read-all');
    return data;
  },
};
